import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import { BackButton } from '../../components/Button';
import { ProductTransactionTypeForm } from '../../components/Forms';
import { Loading } from '../../components/Loading';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';

export default function EditProductTransactionType({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const productTransactionType = useSelector(
    (state) => state.productTransactionType,
  );
  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm({
    defaultValues: {
      name: productTransactionType.name,
      direction: productTransactionType.direction,
    },
  });

  useEffect(() => {
    dispatch(actions.productTransactionTypeGet(id));
    return () => { };
  }, []);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const onSubmit = async (data) => {
    try {
      // console.log(data);
      await dispatch(actions.productTransactionTypePut(id, data));
      await dispatch(actions.productTransactionTypeGet(id));
      alert('สำเร็จ');
    } catch (error) {
      console.log(error);
    }
  };
  if (productTransactionType.isLoading || productTransactionType.rows) {
    return <Loading />;
  }
  if (!productTransactionType.isLoading && productTransactionType.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
          <div className="text-lg font-semibold ml-6">
            แก้ไขข้อมูลประเภทการดำเนินการ
          </div>
        </div>
        <div>
          <Card className="p-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <ProductTransactionTypeForm
                errors={errors}
                productTransactionType={productTransactionType}
                control={control}
                Controller={Controller}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button
                  variant="contained"
                  type="submit"
                  startIcon={<SaveIcon />}
                >
                  บันทึก
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}

EditProductTransactionType.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditProductTransactionType.defaultProps = {
  title: '',
  subtitle: '',
};
